module.exports = __webpack_public_path__ + "66e1972196c6d844b2f1cc33cabe4424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-cashrewards.png
// module id = 409
// module chunks = 0